export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Главная", "item": { "@id": "https://business-training.by/", "name": "Главная" } },
          { "@type": "ListItem", "position": 2, "name": "Энциклопедия корпоративного обучения", "item": { "@id": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie", "name": "Энциклопедия корпоративного обучения" } },
          { "@type": "ListItem", "position": 3, "name": "Тренинг для руководителей", "item": { "@id": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley", "name": "Тренинг для руководителей" } }
        ]
      },
      {
        "@type": "Service",
        "name": "Тренинг для руководителей",
        "description": "Корпоративный тренинг для руководителей в Минске и Беларуси. Развитие лидерства, управления командой, делегирования, мотивации и принятия решений. Практическое обучение для руководителей компаний.",
        "provider": {
          "@type": "Organization",
          "name": "BusinessTraining.by",
          "url": "https://business-training.by",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Минск",
            "addressCountry": "BY"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+375255024478",
            "contactType": "sales"
          }
        },
        "areaServed": ["BY", "RU", "KZ", "IL"],
        "serviceType": "Корпоративное обучение руководителей",
        "offers": {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Программа обучения руководителей"
          }
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          { "@type": "Question", "name": "Что входит в тренинг для руководителей?", "acceptedAnswer": { "@type": "Answer", "text": "Тренинг для руководителей включает диагностику управленческой команды, определение целей бизнеса, подготовку индивидуальной программы, практические занятия с разбором реальных кейсов, внедрение инструментов управления, сопровождение руководителей и оценку изменений." } },
          { "@type": "Question", "name": "Чем обучение руководителей отличается от MBA?", "acceptedAnswer": { "@type": "Answer", "text": "MBA даёт широкую теоретическую базу по всем аспектам бизнеса, в то время как тренинг для руководителей — это практическое обучение конкретным управленческим навыкам на реальных кейсах компании. Тренинг фокусируется на применении инструментов здесь и сейчас, а не на общей бизнес-теории." } },
          { "@type": "Question", "name": "Подходит ли обучение для начинающих руководителей?", "acceptedAnswer": { "@type": "Answer", "text": "Да, программа адаптируется под уровень участников. Для начинающих руководителей делается акцент на базовых управленческих навыках: постановка задач, контроль исполнения, обратная связь и делегирование. Для опытных — на стратегическом лидерстве и управлении изменениями." } },
          { "@type": "Question", "name": "Можно ли обучить руководителей среднего звена?", "acceptedAnswer": { "@type": "Answer", "text": "Да, руководители среднего звена — одна из ключевых аудиторий. Обучение помогает им выстроить эффективное взаимодействие как с подчинёнными, так и с топ-менеджментом, освоить инструменты операционного управления и развить лидерские компетенции." } },
          { "@type": "Question", "name": "Как проходит диагностика управленческой команды?", "acceptedAnswer": { "@type": "Answer", "text": "Диагностика включает интервью с руководителями, анализ управленческих процессов, оценку компетенций по модели компетенций, сбор обратной связи от сотрудников (360 градусов) и анализ ключевых бизнес-показателей подразделений." } }
        ]
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер, консультант, фасилитатор",
        "description": "18+ лет практики в корпоративном обучении и управлении. 100+ корпоративных проектов, 450+ тренингов, 4500+ участников.",
        "url": "https://www.linkedin.com/in/alekseysivko",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "Organization",
        "name": "BusinessTraining.by",
        "url": "https://business-training.by",
        "description": "Корпоративное обучение руководителей и сотрудников в Минске, Беларуси и онлайн. Тренинги, стратегические сессии, фасилитация и коучинг.",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Минск",
          "addressCountry": "BY"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+375255024478",
          "contactType": "sales"
        }
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}